import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ScrollWidthService {
  private _scrollWidth = 0;
  public get scrollWidth(): number {
    return this._scrollWidth;
  }
  public set scrollWidth(v: number) {
    this._scrollWidth = v;
    this.scrollWidth$.next(v);
  }

  public scrollWidth$ = new BehaviorSubject<number>(this._scrollWidth);
  public observer: MutationObserver = new MutationObserver(
    this.onMutate.bind(this)
  );

  constructor() {
    this.observer.observe(document.body, {
      attributes: true,
    });
  }

  public onMutate(e) {
    const offset = parseInt(document.body.style.paddingRight || '0', 10);

    if (offset !== this.scrollWidth) {
      this.scrollWidth = offset;
    }
  }
}
